module.exports = __webpack_public_path__ + "img/ID.b0ffd368.webp";